export const iconFontAwesomeSocialImage = (
	<i className="fa-solid fa-image"></i>
);
